import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Suspense, memo, useEffect, useLayoutEffect, useRef, useState, useTransition } from "react";
import CacheComponent from "../CacheComponent";
import KeepAliveProvider from "../KeepAliveProvider";
import { isNil, omit } from "lodash-es";
import { useAppStore } from "../../../../../store";
import { transformPathToSnakeCase } from "../../../../../utils/transformPathToSnakeCase";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function KeepAliveComp(props) {
  var activeName = props.activeName,
    cache = props.cache,
    children = props.children,
    maxLen = props.maxLen,
    needRefresh = props.needRefresh;
  var refreshPath = useAppStore(function (s) {
    return s.refreshPath;
  });
  var homePath = useAppStore(function (s) {
    return s.homePath;
  });
  var _useTransition = useTransition(),
    _useTransition2 = _slicedToArray(_useTransition, 2),
    startTransition = _useTransition2[1];
  var renderDiv = useRef(null);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    cacheReactNodes = _useState2[0],
    setCacheReactNodes = _useState2[1];
  useEffect(function () {
    useAppStore.setState({
      tabCacheHandlers: {
        getCaches: function getCaches() {
          return cacheReactNodes;
        },
        removeCache: function removeCache(path) {
          setTimeout(function () {
            setCacheReactNodes(function (cacheReactNodes) {
              var _renderDiv$current;
              var targetElement = (_renderDiv$current = renderDiv.current) === null || _renderDiv$current === void 0 ? void 0 : _renderDiv$current.querySelector("#".concat(transformPathToSnakeCase(path)));
              if (targetElement) {
                var _renderDiv$current2;
                (_renderDiv$current2 = renderDiv.current) === null || _renderDiv$current2 === void 0 || _renderDiv$current2.removeChild(targetElement);
              }
              return cacheReactNodes.filter(function (_ref) {
                var pathname = _ref.pathname;
                return pathname !== path;
              });
            });
          }, 0);
        },
        cleanAllCache: function cleanAllCache() {
          setTimeout(function () {
            var _renderDiv$current3;
            var targetElements = (_renderDiv$current3 = renderDiv.current) === null || _renderDiv$current3 === void 0 ? void 0 : _renderDiv$current3.querySelectorAll(".keep-alive-sign .cache-component");
            targetElements === null || targetElements === void 0 || targetElements.forEach(function (targetElement) {
              if (targetElement && targetElement.id !== transformPathToSnakeCase(homePath)) {
                var _renderDiv$current4;
                (_renderDiv$current4 = renderDiv.current) === null || _renderDiv$current4 === void 0 || _renderDiv$current4.removeChild(targetElement);
              }
            });
            setCacheReactNodes([]);
          }, 0);
        },
        cleanOtherCache: function cleanOtherCache(paths) {
          setTimeout(function () {
            var transformPaths = paths.map(function (path) {
              return transformPathToSnakeCase(path);
            });
            var targetElements = transformPaths.map(function (path) {
              var _renderDiv$current5;
              return (_renderDiv$current5 = renderDiv.current) === null || _renderDiv$current5 === void 0 ? void 0 : _renderDiv$current5.querySelector("#".concat(path));
            });
            targetElements.forEach(function (targetElement) {
              if (targetElement && !transformPaths.includes(targetElement.id)) {
                var _renderDiv$current6;
                (_renderDiv$current6 = renderDiv.current) === null || _renderDiv$current6 === void 0 || _renderDiv$current6.removeChild(targetElement);
              }
            });
            setCacheReactNodes(function (cacheReactNodes) {
              return cacheReactNodes.filter(function (_ref2) {
                var pathname = _ref2.pathname;
                return paths.includes(pathname);
              });
            });
          }, 0);
        }
      }
    });
  }, [cacheReactNodes]);
  useLayoutEffect(function () {
    if (isNil(activeName)) {
      return;
    }
    setCacheReactNodes(function (cacheReactNodes) {
      var newCacheReactNodes = cacheReactNodes;
      if (newCacheReactNodes.length >= (maxLen || 30)) {
        newCacheReactNodes = newCacheReactNodes.slice(1, newCacheReactNodes.length);
      }
      var panes = useAppStore.getState().panes;
      // remove cache false
      newCacheReactNodes = newCacheReactNodes.filter(function (_ref3) {
        var cache = _ref3.cache,
          pathname = _ref3.pathname;
        return cache && panes.some(function (pane) {
          return pane.path === pathname;
        });
      });
      var cacheReactNode = newCacheReactNodes.find(function (res) {
        return res.pathname === activeName;
      });
      if (isNil(cacheReactNode)) {
        newCacheReactNodes.push({
          cache: cache !== null && cache !== void 0 ? cache : true,
          pathname: activeName,
          // props: activeProps,
          ele: children
        });
      } else {
        // important update children when activeName is same
        // this can trigger children onActive
        newCacheReactNodes = newCacheReactNodes.map(function (res) {
          return res.pathname === activeName ? omit(_objectSpread(_objectSpread({}, res), {}, {
            ele: children
          }), "refreshSign") : omit(res, "refreshSign");
        });
      }
      // refresh node
      if (refreshPath) {
        var pureRefreshPath = refreshPath.split("@@")[0];
        var refreshNode = newCacheReactNodes.find(function (el) {
          return el.pathname === pureRefreshPath;
        });
        if (refreshNode) {
          refreshNode.refreshSign = refreshPath;
        }
      }
      // search changed & refresh
      if (needRefresh) {
        var _refreshNode = newCacheReactNodes.find(function (el) {
          return el.pathname === activeName;
        });
        if (_refreshNode) {
          _refreshNode.refreshSign = activeName + Math.random();
        }
      }
      return newCacheReactNodes;
    });
  }, [children, cache, activeName, maxLen, refreshPath]);
  useLayoutEffect(function () {
    if (refreshPath) {
      startTransition(function () {
        useAppStore.setState({
          refreshPath: null
        });
      });
    }
  }, [refreshPath]);
  return /*#__PURE__*/_jsxs(Suspense, {
    children: [/*#__PURE__*/_jsx("div", {
      ref: renderDiv,
      className: "keep-alive-sign"
    }), /*#__PURE__*/_jsx(KeepAliveProvider, {
      initialActiveName: activeName,
      children: cacheReactNodes === null || cacheReactNodes === void 0 ? void 0 : cacheReactNodes.map(function (_ref4) {
        var pathname = _ref4.pathname,
          cache = _ref4.cache,
          ele = _ref4.ele,
          refreshSign = _ref4.refreshSign;
        return /*#__PURE__*/_jsx(CacheComponent, {
          active: pathname === activeName,
          renderDiv: renderDiv,
          cache: cache,
          name: pathname,
          children: ele
        }, refreshSign || pathname);
      })
    })]
  });
}
var KeepAlive = /*#__PURE__*/memo(KeepAliveComp, function (prevProps, nextProps) {
  return prevProps.activeName === nextProps.activeName;
});
export default KeepAlive;